import { Box, Chip, Stack, styled } from '@planne-software/uni/mui/material';
import { uni } from '@planne-software/uni/v2';

import { tabletBreakpoint } from '@src/common/utils/mediaQuery';
import { uniTypography } from '@src/fonts/typography/uniTypography';

export const ReservationCardRoot = styled(Stack)(() => ({
  display: 'flex',
  flexDirection: 'column',
  gap: uni('spacing-24-16'),
  width: '100%',
  padding: uni('padding-content'),
  borderRadius: uni('border-radius-xs'),
  backgroundColor: uni('bg-static-content-highlight'),
}));

export const ReservationInfo = styled(Stack)(() => ({
  display: 'flex',
  flexDirection: 'column',
  gap: uni('scale-200'),
  width: '100%',
}));

export const ReservationTitle = styled('p')`
  ${uniTypography('text-md', 'semibold')}
  color: ${uni('fg-neutral-static-default-heading')};
  margin: 0;
`;

export const ReservationRow = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  gap: uni('scale-100'),
  color: uni('fg-neutral-static-default-body'),
}));

export const ReservationScheduleGroup = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  flexWrap: 'wrap',
  gap: uni('scale-200'),
}));

export const ReservationRowText = styled('span')`
  ${uniTypography('text-sm', 'medium')}
  color: ${uni('fg-neutral-static-default-body')};
`;

export const ReservationChipList = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'row',
  flexWrap: 'wrap',
  alignItems: 'center',
  gap: uni('scale-100'),
  width: '100%',
}));

export const ReservationChip = styled(Chip)(() => ({
  height: 'auto',
  borderRadius: uni('border-radius-round'),
  border: `1px solid ${uni('border-neutral-subtle-rest')}`,
  backgroundColor: uni('bg-neutral-subtle-rest'),

  '& .MuiChip-label': {
    ...uniTypography('text-sm', 'medium'),
    color: uni('fg-neutral-action-on-color-subtle-rest'),
    padding: `${uni('scale-50')} ${uni('scale-200')}`,
  },
}));

export const ReservationActionsRow = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'flex-end',
  gap: uni('scale-400'),
  width: '100%',

  [tabletBreakpoint]: {
    flexDirection: 'column-reverse',
    alignItems: 'stretch',
    gap: uni('scale-200'),

    '& > *, & button': {
      width: '100%',
    },
  },
}));
